module.exports = __webpack_public_path__ + "media/images/icon-arrow-left-green-c0347ccacef0378ac0a4355f45894bbb.svg";